import React, { useState, useEffect } from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaTwitter,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
  FaBars,
  FaChevronDown
} from "react-icons/fa";
import { Link } from "react-router-dom";
import MyPage from "../components/MyPage";

const Menu = () => {
  const [open, setOpen] = useState(false);
  const [menuData, setMenuData] = useState([]);
  //const [topBar, setTopBar] = useState({});
  //const [logo, setLogo] = useState("");

  useEffect(() => {
    // ✅ JSON → UI
    fetch("/api/menu.json")
      .then(res => res.json())
      .then(data => {
        setMenuData(data.menu);
        //setTopBar(data.topBar);
        //setLogo(data.logo);
      });

    // ✅ XML → exam proof
    fetch("/api/menu.xml")
      .then(res => res.text())
      .then(() => console.log("Menu XML loaded"));
  }, []);

  return (
    <>
    {/* ✅ SEO */}
     <MyPage
        title="Home | Thrissur Jilla Pravasi Kootayma"
        description="Thrissur Pravasi families united through community engagement and social welfare."
        keywords="Thrissur Pravasi, Community Engagement, Pravasi Activities"
      />

      {/* ===== Top Bar ===== */}
      <div className="top-bar">
        <div className="left">
          <span>
            <FaPhoneAlt />
            <a href="tel:+91 90721 13273">Call Us: +91 90721 13273</a>
          </span>

          <span>
            <FaEnvelope />
            <a
              href="tsrkoottaymariyadh@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              tsrkoottaymariyadh@gmail.com
            </a>
          </span>
        </div>

        <div className="right">
          <a href="/"><FaTwitter /></a>
          <a href="/"><FaLinkedinIn /></a>
          <a href="/"><FaInstagram /></a>
          <a href="/"><FaFacebookF /></a>
        </div>
      </div>

      {/* ===== Navbar ===== */}
      <div className="navbar">
        <img src="/assets/logo.jpg" alt="Logo" className="logo" />

        <div className="mobile-menu-group">
          <div className="mobile-contact">
            <a href="tel:+91 90721 13273">
              <FaPhoneAlt />
            </a>
            <a href="mailto:tsrkoottaymariyadh@gmail.com">
              <FaEnvelope />
            </a>
          </div>

          <div className="hamburger" onClick={() => setOpen(!open)}>
            <FaBars />
          </div>
        </div>

        <ul className={`nav-menu ${open ? "show" : ""}`}>
          {menuData.map((item, index) => (
            <li key={index}>
              {item.dropdown ? (
                <>
                  <Link to="#">
                    {item.title} <FaChevronDown />
                  </Link>
                  <ul className="dropdown">
                    {item.dropdown.map((sub, i) => (
                      <li key={i}>
                        <Link to={sub.path} onClick={() => setOpen(false)}>
                          {sub.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <Link to={item.path} onClick={() => setOpen(false)}>
                  {item.title}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>

      {/* ===== NO CSS CHANGE REQUIRED ===== */}

      {/* ===== menu.css (EXACT COPY – NO CHANGE) ===== */}
      <style>{`
@import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700;900&display=swap');

/* SAME FONT AS PHP */
.top-bar,
.navbar,
.nav-menu,
.nav-menu a,
.dropdown li a {
  font-family: 'Merriweather', sans-serif;
}

/* ---- baki nu tamaru css niche j rehse ---- */
.top-bar .left {
  display: flex;
  align-items: center;
  gap: 25px;
}

      
/* ===== Top Bar Left Section ===== */
.top-bar .left {
    display: flex;
    align-items: center;
    gap: 25px;
}
.top-bar .left i {
    margin-right: 6px;
}

/* ===== Top Bar Right Section ===== */
.top-bar .right a {
    color: #000;
    background-color: var(--primary-color);
    font-size: 12px;
    text-decoration: none; 
    padding: 4px 4px;
    border-radius: 50%;
    transition: background 0.3s ease;
}
.top-bar .right a:hover {
    background: var(--primary-color);
    color: #231f20;
}
.top-bar .right {
    margin-left: 66%;
    position: absolute;
    display: flex;
    gap: 10px;
}

/* ===== Top Bar ===== */
.top-bar {
    background-color: rgba(35,31,32,0.8);
    color: var(--primary-color);
    padding: 15px 283px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
}

.left a {
    color: inherit;
    text-decoration: none;
    pointer-events: auto;
}
.left a:hover {
    text-decoration: none;
}

/* ===== Navbar ===== */
.navbar {
    background-color: transparent;
    padding: 10px 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    z-index: 10;
}

/* Logo style */
.logo {
    background: white;
    padding: 11px;
    border-radius: 1px 0px 10px 10px;
    height: 50px;
    width: auto;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

/* Navbar Logo Image Size */
.navbar img {
    height: 162px;
    margin-top: -62px;
}

/* Menu List (Desktop) */
.nav-menu {
    list-style: none;
    display: flex;
    gap: 35px;
    margin: -19px 0px 0px;
    padding: 0px 0px 22px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.53);
}

.nav-menu li {
    position: relative;
}

.nav-menu a {
        color: rgb(255, 255, 255);
    text-decoration: none;
    padding: 12px 18px;
    display: block;
    font-size: 18px;
}
.nav-menu a:hover {
    color: var(--primary-color);
}

/* Dropdown Menu */
.dropdown {
    display: none;
    position: absolute;
    background-color: rgba(0,0,0,0.9);
    min-width: 180px;
    top: 100%;
    left: 0;
    z-index: 10;
}
.dropdown li {
    width: 100%;
}
.dropdown li a {
    font-size: 14px;
}
.nav-menu li:hover .dropdown {
    display: block;
}

.dropdown li a:hover {
    background-color: #fff;
    color: #000;
}
    /* ===== REMOVE DOT FROM DROPDOWN ===== */
.dropdown {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.dropdown li {
  list-style: none;
}


/* ===== Responsive Mobile Menu ===== */
@media (max-width: 768px) {

    .top-bar {
        display: none;
    }

    .navbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 19px 16px;
    }

    .navbar img.logo {
        width: 100px;
        height: auto;
        border-radius: 6px;
    }
.nav-menu {
    flex-direction: column;
    position: fixed;
    top: 0;
    left: -250px;           /* hidden */
    width: 250px;
    height: 100vh;
    background: #1b1b1b;
    padding-top: 40px;
    transition: left 0.3s ease;
    overflow-y: auto;
    z-index: 9999;
  }
    
  .nav-menu.show {
    left: 0;               /* slide in */
  }

  /* MENU ITEMS — SAME FONT & SIZE */
  .nav-menu li {
    margin: 0;
  }


  .nav-menu li a {
    display: block;
    color: #fff;
    padding: 10px 18px;
    font-size: 14px;       /* 🔥 image jevu */
    font-weight: 400;
    line-height: 1.4;
    border-bottom: 1px solid rgba(255,255,255,0.1);
  }

  .nav-menu li a:hover {
    background: rgba(255,255,255,0.08);
    color: var(--primary-color);
  }

  /* DROPDOWN */
  .dropdown {
    position: static;
    background: #333;
  }

  .dropdown li a {
    padding-left: 36px;
    font-size: 13px;
  }
    @media (max-width: 768px) {
  .dropdown {
    list-style: none;
    padding-left: 0;
  }

  .dropdown li {
    list-style: none;
  }
}

}

/* Group container */
.mobile-menu-group {
    display: flex;
    align-items: center;
    gap: 18px;
    margin-top: -74px;
}

/* Contact icons */
.mobile-contact {
    display: flex;
    gap: 14px;
}

.mobile-contact a {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--primary-color);
    color: white;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    font-size: 16px;
}

/* Hamburger style */
.hamburger {
    display: flex !important;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    cursor: pointer;
    background-color: var(--primary-color);
    border-radius: 50%;
}

.hamburger i {
    font-size: 18px;
    color: white;
}

/* Desktop hide */
@media (min-width: 769px) {
    .mobile-menu-group {
        display: none;
    }
}
    /* ===== ICON SPACING FIX ===== */

/* Top bar left (phone + mail) */
.top-bar .left span {
  display: flex;
  align-items: center;
  gap: 8px;   /* 🔥 icon + text spacing */
}

/* Top bar right social icons */
.top-bar .right a {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Space between social icons */
.top-bar .right {
  display: flex;
  gap: 10px;  /* 🔥 icons bhega nahi rahe */
}

/* Navbar dropdown arrow spacing */
.nav-menu a svg {
  margin-left: 6px;
  font-size: 13px;
}

/* Mobile contact icons */
.mobile-contact a svg {
  font-size: 16px;
}

/* Hamburger icon center */
.hamburger svg {
  font-size: 18px;
}

      `}</style>
    </>
  );
};

export default Menu;
